import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import { ROLES } from "../../constants/UserRoles";
import Utils from "../../utils/Utils";
import ProfileUpdateModal from "../../components/modals/ProfileUpdateModal";
import DashboardLandingPage from "../../components/orgAdmin/dashboard/DashboardLandingPage";

function OrgAdminDashboard() {
  const userDetails = Utils.getUserDetail();
  const [updateProfileFlag, setUpdateProfileFlag] = useState(false);
  const [userDataChanged, setuserDataChanged] = useState(1);

  useEffect(() => {
    if (userDetails?.updateProfileInfoFlag) {
      setUpdateProfileFlag(true);
    }
  }, [userDetails?.updateProfileInfoFlag]);

  const handleCancelModal = () => {
    setUpdateProfileFlag(false);
    Utils.setUserDetail({ ...userDetails, updateProfileInfoFlag: false });
    setuserDataChanged((prev) => prev + 1);
  };

  return (
    <>
      {updateProfileFlag && (
        <ProfileUpdateModal
          open={updateProfileFlag}
          handleCancel={handleCancelModal}
          userIdentifier={userDetails?.userIdentifier}
        />
      )}
      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="dashboard" userRole={ROLES.org_admin} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="dashboard"
            userRole={ROLES.org_admin}
            noNavigate={true}
            driverFlag="dashboard"
            newTitle="Dashboard"
            userDataChanged={userDataChanged}
          />
          {/* <DashboardLandingPage /> */}
          <DashboardLandingPage />
        </div>
      </div>
    </>
  );
}

export default OrgAdminDashboard;
